export default {
  env: 'development',
  cookie: 'md-noticejs-sticky-',
  domain: 'mdirector.com',
};



/** WEBPACK FOOTER **
 ** ./src/environments/development.js
 **/